import { Injectable } from '@angular/core';
import { NBS_DATA, NBSItem } from './nbs-data';

@Injectable({
  providedIn: 'root'
})
export class NBSService {

  /**
   * Retorna todos os itens NBS
   */
  getAllNBS(): NBSItem[] {
    return NBS_DATA;
  }

  /**
   * Busca um NBS pelo código
   * @param nbs Código do NBS
   */
  getNBSByCode(nbs: string): NBSItem | undefined {
    return NBS_DATA.find(item => item.nbs === nbs);
  }

  /**
   * Busca NBS por descrição (busca parcial, case insensitive)
   * @param searchText Texto para buscar na descrição
   */
  searchNBSByDescription(searchText: string): NBSItem[] {
    const search = searchText.toLowerCase().trim();
    if (!search) {
      return [];
    }
    return NBS_DATA.filter(item => 
      item.description.toLowerCase().includes(search)
    );
  }

  /**
   * Busca NBS por código ou descrição
   * @param searchText Texto para buscar no código ou descrição
   */
  searchNBS(searchText: string): NBSItem[] {
    const search = searchText.toLowerCase().trim();
    if (!search) {
      return [];
    }
    return NBS_DATA.filter(item => 
      item.nbs.toLowerCase().includes(search) ||
      item.description.toLowerCase().includes(search)
    );
  }
}
